/**
 * Displays a mailing address with optional name/organization.
 *
 * @example
 * ```jsx
 * <Address
 *   name="Centre for Sexuality"
 *   street="Unit 101 - 1509 Centre St S"
 *   city="Calgary"
 *   province="AB"
 *   postalCode="T2G 2E6"
 * />
 * ```
 */

export type AddressProps = {
  /** The name or organization at this address */
  name?: string;
  /** Street address including unit/suite number */
  street: string;
  /** City name */
  city: string;
  /** Province or state code */
  province: string;
  /** Postal or zip code */
  postalCode: string;
};

export const Address = ({
  name,
  street,
  city,
  province,
  postalCode,
}: AddressProps) => (
  <>
    {name && (
      <>
        {name}
        <br />
      </>
    )}
    {street}
    <br />
    {city}, {province}
    <br />
    {postalCode}
  </>
);
